import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { classNames } from '../../../Services/helpers';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { useKeyboardHelper } from '../../Mobile';

/*
Types

color
date
datetime-local
email
month
number
search
tel
text
time
url
week
*/

const fallbackValue = '';

const TextField = ({label, name, help, onChange, type, placeholder, prefix, suffix, suffixOnClick, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const {hideNav, showNav} = useKeyboardHelper(`form-field-${name}`);
    const value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const handleChange = (e) => {
        updateField(name, e.target.value);
        onChange && onChange(e.target.value);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <div className="relative flex flex-row">
            <div className="pointer-events-none inset-y-0 left-0 flex items-center pr-1">
                <span className="sm:text-sm">{prefix}</span>
            </div>

            <input className="block w-full border-0 p-0 surface-1 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                type={type}
                // pattern="\d*"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={isDisabled}
                onFocus={hideNav}
                onBlur={showNav}
            />

            <div className={classNames(
                    'inset-y-0 right-0 flex items-center pl-1',
                    suffixOnClick ? 'cursor-pointer' : 'pointer-events-none'
                )}
                onClick={() => suffixOnClick && suffixOnClick()}
            >
                <span className="sm:text-sm">{suffix}</span>
            </div>
        </div>

    </CommonFieldWrapper>
}

export default TextField;
